@if (pageReady) {
  <main class="gs-page">
    <div class="wallet-container">
      <app-page-header [headerData]="headerData"></app-page-header>
      <div class="notification-container">
        <app-notification [pageName]="pageName"></app-notification>
      </div>
      <div class="gs-content-container">
        <div class="top-content-container">
          <div class="all-paymethod-container">
            @if (paymethods.length !== 0) {
              <div class="pay-method-container">
                <div class="list-header">
                  <h3>{{ pageLabels.cardsAccountsHeadlineText }}</h3>
                </div>
                <form [formGroup]="walletForm">
                  <mat-accordion class="paymethod-list" multi formArrayName="PayForms">
                    @for (paymethod of paymethods; let i = $index; track paymethod) {
                      <mat-expansion-panel
                        #panel
                        [hideToggle]="paymethod.BankCardDigital === 'DIGITAL'"
                        (opened)="closeDigitalPanel(paymethod, panel)"
                      >
                        <mat-expansion-panel-header class="paymethod-header">
                          <div class="panel-header-container">
                            <div class="method-img" [innerHTML]="getPayMethodIcon(paymethod)"></div>
                            <div class="method-details">
                              <p class="method-header">
                                {{ paymethod.Nickname ?? (paymethod.PaymentAccountType | patDisplayName) }}
                              </p>
                              <div class="method-status">
                                @if (paymethod.IsDefault) {
                                  <p>{{ pageLabels.defaultPanelText }}</p>
                                }
                                @if (paymethod.IsAssociatedAutoPay) {
                                  <p>{{ pageLabels.autoPayPanelText }}</p>
                                }
                                @if (paymethod.IsExpired) {
                                  <p class="paymethod-expired">{{ pageLabels.expiredPanelText }}</p>
                                }
                              </div>
                            </div>
                            @if (paymethod.BankCardDigital !== "DIGITAL") {
                              <p class="method-description">...{{ paymethod.LastFour }}</p>
                            } @else {
                              <button
                                id="Remove-{{ i }}"
                                class="gs-button-link"
                                [attr.aria-label]="getBtnAriaLabel(paymethod, 'remove')"
                                (keydown.enter)="deletePayMethod(paymethod)"
                                (keydown.space)="deletePayMethod(paymethod)"
                                (click)="deletePayMethod(paymethod)"
                              >
                                {{ pageLabels.removePaymentText }}
                              </button>
                            }
                          </div>
                        </mat-expansion-panel-header>
                        <div>
                          @if (paymethod.BankCardDigital === "BANK") {
                            <form class="paymethod-form bank-form" [formGroupName]="i">
                              <div class="top-row">
                                <mat-form-field class="routing-number" appearance="outline" color="primary">
                                  <mat-label>{{ pageLabels.routingNumberLabelText }}</mat-label>
                                  <input
                                    readonly
                                    type="text"
                                    matInput
                                    data-private
                                    [value]="paymethod.BankRoutingNumber"
                                  />
                                </mat-form-field>
                                <div class="mid-row">
                                  <mat-form-field class="account-number" appearance="outline" color="primary">
                                    <mat-label>{{ pageLabels.accountNumberLabelText }}</mat-label>
                                    <input
                                      formControlName="AccountNumber"
                                      matInput
                                      type="text"
                                      id="accountNumber"
                                      data-private
                                      [specialCharacters]="['*']"
                                      mask="******0000"
                                      [dropSpecialCharacters]="true"
                                    />
                                  </mat-form-field>
                                  <mat-form-field class="account-type" appearance="outline" color="primary">
                                    <mat-label>{{ pageLabels.bankAccountTypeLabelText }}</mat-label>
                                    <input readonly type="text" matInput [value]="paymethod.BankAccountType" />
                                  </mat-form-field>
                                </div>
                              </div>
                              <div class="bot-row">
                                <mat-form-field
                                  class="nickname"
                                  appearance="outline"
                                  color="primary"
                                  id="nicknameBank"
                                  subscriptSizing="dynamic"
                                >
                                  <mat-label>{{ pageLabels.nickNameLabelText }}</mat-label>
                                  <input
                                    formControlName="Nickname"
                                    type="text"
                                    maxlength="45"
                                    matInput
                                    (blur)="checkForDuplicateNickName(paymethod, i)"
                                    aria-labelledby="nickNameInvalidCharErrorBank nickNameDuplicateErrorBank"
                                  />
                                  @if (paymentForms.at(i).get("Nickname")?.hasError("invalidCharacters")) {
                                    <mat-error id="nickNameInvalidCharErrorBank">{{
                                      pageLabels.nicknameErrorText
                                    }}</mat-error>
                                  } @else if (paymentForms.at(i).get("Nickname")?.hasError("duplicateNickName")) {
                                    <mat-error id="nickNameDuplicateErrorBank">{{
                                      pageLabels.duplicateNickNameErrorText
                                    }}</mat-error>
                                  }
                                </mat-form-field>
                                <mat-checkbox class="default-cb" formControlName="SetDefault" color="primary">{{
                                  pageLabels.setDefaultPaymentLabelText
                                }}</mat-checkbox>
                              </div>
                              <div class="paymethod-form-btn-container">
                                <button
                                  id="Update-{{ i }}"
                                  [attr.aria-label]="getBtnAriaLabel(paymethod, 'update')"
                                  class="gs-form-button-primary"
                                  mat-flat-button
                                  color="primary"
                                  (click)="updatePayMethod(paymethod, i)"
                                >
                                  {{ pageLabels.updateButtonText }}
                                </button>
                                <button
                                  id="Remove-{{ i }}"
                                  class="gs-button-link"
                                  [attr.aria-label]="getBtnAriaLabel(paymethod, 'remove')"
                                  (click)="deletePayMethod(paymethod)"
                                >
                                  {{ pageLabels.removePaymentText }}
                                </button>
                              </div>
                            </form>
                          } @else if (paymethod.BankCardDigital === "CARD") {
                            <form class="paymethod-form card-form" [formGroupName]="i">
                              <div class="top-row">
                                <mat-form-field class="card-number" appearance="outline" color="primary">
                                  <mat-label>{{ pageLabels.cardNumberLabelText }}</mat-label>
                                  <input
                                    readonly
                                    type="text"
                                    matInput
                                    data-private
                                    formControlName="CardNumber"
                                    [specialCharacters]="['*', ' ']"
                                    [mask]="checkMask(paymethod.PaymentAccountType)"
                                    [dropSpecialCharacters]="true"
                                  />
                                </mat-form-field>
                                <div class="mid-row">
                                  <mat-form-field
                                    class="exp-date"
                                    appearance="outline"
                                    color="primary"
                                    subscriptSizing="dynamic"
                                  >
                                    <mat-label>{{ pageLabels.expirationDateLabelText }}</mat-label>
                                    <input
                                      formControlName="ExpDate"
                                      matInput
                                      type="text"
                                      placeholder="MM/YY"
                                      id="expiration-date"
                                      data-private
                                      [dropSpecialCharacters]="false"
                                      mask="00/00"
                                    />
                                    @if (paymentForms.at(i).get("ExpDate")?.hasError("required")) {
                                      <mat-error id="expDateErrorReq">{{
                                        pageLabels.expirationDateErrorText
                                      }}</mat-error>
                                    } @else if (paymentForms.at(i).get("ExpDate")?.hasError("invalidExpirationDate")) {
                                      <mat-error id="expDateErrorInvalid">{{
                                        pageLabels.invalidExpirationDateErrorText
                                      }}</mat-error>
                                    }
                                  </mat-form-field>
                                  <mat-form-field
                                    class="sec-code"
                                    appearance="outline"
                                    color="primary"
                                    subscriptSizing="dynamic"
                                  >
                                    <mat-label>{{ pageLabels.securityCodeLabelText }}</mat-label>
                                    <input
                                      formControlName="SecurityCode"
                                      type="text"
                                      matInput
                                      data-private
                                      maxlength="4"
                                    />
                                    @if (paymentForms.at(i).get("SecurityCode")?.hasError("required")) {
                                      <mat-error id="securityCodeErrorReq">{{
                                        pageLabels.securityCodeReqErrorText
                                      }}</mat-error>
                                    } @else if (
                                      paymentForms.at(i).get("SecurityCode")?.hasError("invalidSecurityCode")
                                    ) {
                                      <mat-error id="securityCodeErrorInvalid">{{
                                        pageLabels.securityCodeErrorText
                                      }}</mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                              </div>
                              <div class="bot-row">
                                <mat-form-field
                                  class="gs-ff-bottom nickname"
                                  appearance="outline"
                                  color="primary"
                                  subscriptSizing="dynamic"
                                >
                                  <mat-label>{{ pageLabels.nickNameLabelText }}</mat-label>
                                  <input
                                    formControlName="Nickname"
                                    type="text"
                                    maxlength="45"
                                    matInput
                                    (blur)="checkForDuplicateNickName(paymethod, i)"
                                    aria-labelledby="nickNameInvalidCharErrorCard nickNameDuplicateErrorCard"
                                  />
                                  @if (paymentForms.at(i).get("Nickname")?.hasError("invalidCharacters")) {
                                    <mat-error id="nickNameInvalidCharErrorCard">{{
                                      pageLabels.nicknameErrorText
                                    }}</mat-error>
                                  } @else if (paymentForms.at(i).get("Nickname")?.hasError("duplicateNickName")) {
                                    <mat-error id="nickNameDuplicateErrorCard">{{
                                      pageLabels.duplicateNickNameErrorText
                                    }}</mat-error>
                                  }
                                </mat-form-field>
                                <mat-checkbox class="default-cb" formControlName="SetDefault" color="primary">{{
                                  pageLabels.setDefaultPaymentLabelText
                                }}</mat-checkbox>
                              </div>
                              <div class="paymethod-form-btn-container">
                                <button
                                  id="Update-{{ i }}"
                                  [attr.aria-label]="getBtnAriaLabel(paymethod, 'update')"
                                  class="gs-form-button-primary"
                                  mat-flat-button
                                  color="primary"
                                  (click)="updatePayMethod(paymethod, i)"
                                >
                                  {{ pageLabels.updateButtonText }}
                                </button>
                                <button
                                  id="Remove-{{ i }}"
                                  class="gs-button-link"
                                  [attr.aria-label]="getBtnAriaLabel(paymethod, 'remove')"
                                  (click)="deletePayMethod(paymethod)"
                                >
                                  {{ pageLabels.removePaymentText }}
                                </button>
                              </div>
                            </form>
                          } @else {
                            <form class="paymethod-form" [formGroupName]="i"></form>
                          }
                        </div>
                      </mat-expansion-panel>
                    }
                  </mat-accordion>
                </form>
              </div>
            }
            <div class="new-paymethod-container">
              <form [formGroup]="walletForm">
                <div class="new-pay-method">
                  @if (paymethods.length === 0) {
                    <p class="new-paymethod-header">{{ pageLabels.payMethodAddNewHeader }}</p>
                  }
                  <h2>{{ pageLabels.payMethodAddInputHeader }}</h2>
                  <mat-form-field class="payment-list" appearance="outline" color="primary">
                    <mat-label>{{ pageLabels.payMethodAddLabel }}</mat-label>
                    <mat-select
                      formControlName="newPaymethod"
                      aria-label="Add payment method"
                      (selectionChange)="paymethodChanged()"
                    >
                      @for (newMethod of newPaymethodsList; track newMethod) {
                        <mat-option class="new-paymethod-option" [value]="newMethod">
                          {{ newMethod.Description }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </form>
            </div>
          </div>
          @if (paymethods.length !== 0) {
            <app-side-panel [panelData]="sidePanelData"></app-side-panel>
          }
        </div>
        <div class="page-link-container">
          <mat-divider class="divider"></mat-divider>
          <button
            (click)="goToAccountSummary()"
            role="link"
            class="gs-form-button-primary"
            mat-flat-button
            color="primary"
          >
            {{ pageLabels.accountSummaryBtnText }}
          </button>
        </div>
      </div>
    </div>
    <ng-template #deletePaymentDialogTemplate let-data>
      <div class="form-wrapper">
        <h2>{{ data.title }}</h2>
        <div class="dialog-content">
          <p>{{ data.content }}</p>
        </div>
        <div class="buttons-wrapper">
          <button
            id="cancelBtn"
            type="button"
            mat-flat-button
            mat-dialog-close
            [attr.aria-label]="pageLabels.deletePaymentMethodCancelLinkAriaLabel"
            class="gs-form-button-primary cancel-button"
            color="primary"
          >
            {{ pageLabels.deletePaymentMethodCancelButtonText }}
          </button>
          @if (showDialogConfirmButton) {
            <button
              id="confirmBtn"
              type="button"
              mat-flat-button
              mat-dialog-close
              [attr.aria-label]="pageLabels.deletePaymentMethodCancelLinkAriaLabel"
              class="gs-form-button-primary"
              color="primary"
            >
              {{ pageLabels.deletePaymentMethodConfirmButtonText }}
            </button>
          }
          @if (showDialogContinueButton) {
            <button
              id="continueBtn"
              mat-flat-button
              class="gs-form-button-primary"
              color="primary"
              [mat-dialog-close]="true"
              [attr.aria-label]="pageLabels.deletePaymentMethodButtonContinueAriaLabel"
            >
              {{ this.pageLabels.deletePaymentMethodButtonContinueText }}
            </button>
          }
        </div>
      </div>
    </ng-template>
  </main>
}
